module.exports = __webpack_public_path__ + "static/img/davis_pictgrid41_960x845.b498f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid41_960x845.jpg
// module id = rmoc
// module chunks = 0